import BaseStore from "@/stateManagement/BaseStore";
import { StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

import { RewardsB2bCompanyPointBalanceEntity } from "../models/RewardsB2bCompanyEntities";

export interface RewardsB2bCompanyState {
    b2bCompanyPointBalance: RewardsB2bCompanyPointBalanceEntity | null;
}

const createInitialState = (): RewardsB2bCompanyState => ({
    b2bCompanyPointBalance: null,
});

@singleton()
@StoreConfig({ name: "RewardsB2bCompanyStore" })
class RewardsB2bCompanyStore extends BaseStore<RewardsB2bCompanyState> {
    constructor() {
        super(createInitialState());
    }
}

export default RewardsB2bCompanyStore;
